module.exports = __webpack_public_path__ + "img/time-gray.2fad0968.svg";